// Common API response enum
export enum STATUS_CODE {
    SUCCESS = 'success',
    FAIL = 'fail',
}

// Generic API response wrapper
export interface IApiResponse<T> {
    resultType: string;
    errorMessage: string | null;
    errorCode: string | null;
    validationErrors: string[] | null;
    data: T;
}
